<template>
  <div class="home-wrap">
    <!-- 顶部 -->
    <div class="home-top-wrap">
      <!-- 城市定位 -->
      <div class="top-header">
        <div class="header-left">
          <span class="iconfont icondizhi"></span><span class="city-name">虎门镇</span><span
            class="iconfont iconyoujiantou"></span>
        </div>
        <div class="header-center"></div>
        <div class="header-right"></div>

      </div>
      <!-- 轮播图 -->
      <div class="swipe-wrap" v-if="BannerList.length > 0">
        <div class="swipe-content">
          <van-swipe class="my-swipe" ref="mySwipe" :show-indicators="true" :autoplay="5000">
            <van-swipe-item v-for="(item, index) in BannerList" :key="index">
              <div class="swipe-inner">
                <div class="swipe-inner-img" :style="{ height: imgHeight }">
                  <van-image width="100%" :height="imgHeight" fit="cover" :src="item.Url" />
                </div>
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
    </div>
    <!-- 顶部 end -->
    <!-- 菜单 -->
    <div class="menu-list-wrap">
      <div class="menu-wrap">
        <!-- 图标列表 -->
        <div>
          <div class="menu-body">
            <div class="menu-item" v-for="(item, index) in MenuList" :key="index">
              <div class="menu-item-inner">
                <div class="menu-item-inner-inner" @click="selectMenu(item)">
                  <van-image width="100%" height="100%" fit="cover" :src="item.MenuIcon" />
                </div>
              </div>
              <div class="menu-item-name">{{ item.MenuName }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 菜单 end -->

    <!-- 新顾客 -->
    <div class="promotions-wrap">
      <div class="promotions-title">
        <van-image width="100%" height="100%" fit="cover" src="http://www.lungchuenjz.cn/upload/images/index2/floor/h23.png" />
      </div>
      <!-- 图标列表 -->
      <div>
        <div class="promotions-body">
          <div class="promotions-item" v-for="(item, index) in promotionsList" :key="index">
            <div class="promotions-item-inner">
              <div class="promotions-item-inner-inner" @click="selectMenu(item)">
                <van-image width="100%" height="100%" fit="cover" :src="item.MenuIcon" />
              </div>
            </div>
            <!-- <div class="promotions-item-name">{{ item.MenuName }}</div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- 新顾客 end -->

    <!-- 活动专区 -->
    <div class="promotions-wrap">
      <div class="promotions-title">
        <van-image width="100%" height="100%" fit="cover" src="http://www.lungchuenjz.cn/upload/images/index2/floor/h23.png" />
      </div>
      <!-- 图标列表 -->
      <div>
        <div class="promotions-body">
          <div class="promotions-item" v-for="(item, index) in promotionsList" :key="index">
            <div class="promotions-item-inner">
              <div class="promotions-item-inner-inner" @click="selectMenu(item)">
                <van-image width="100%" height="100%" fit="cover" :src="item.MenuIcon" />
              </div>
            </div>
            <!-- <div class="promotions-item-name">{{ item.MenuName }}</div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- 活动专区 end -->

  </div>
</template>

<script>
export default {
  data() {
    return {
      BannerList: [
        { Url: "https://cloudimage.qxdaojia.com/gooods/1656499196238-2e6fed97-3231-48f5-b6f2-bb76aa8fab26.gif" },
        { Url: "https://cloudimage.qxdaojia.com/gooods/1656499216404-31e6f226-93b8-428f-9619-29af8677ef91.gif" },
        { Url: "https://cloudimage.qxdaojia.com/gooods/1656499119584-45eb5e3c-1674-4f7d-8686-354c5ec398a9.gif" }
      ],
      imgHeight: "",
      MenuList: [
        { MenuName: "家庭保洁", MenuIcon: "https://cloudimage.qxdaojia.com/gooods/1655861334482-1.png" },
        { MenuName: "保姆月嫂", MenuIcon: "https://cloudimage.qxdaojia.com/gooods/1655861340623-2.png" },
        { MenuName: "家电清洗", MenuIcon: "https://cloudimage.qxdaojia.com/gooods/1655861366281-6.png" },
        { MenuName: "收纳整理", MenuIcon: "https://cloudimage.qxdaojia.com/gooods/1655861393101-10.png" },
        { MenuName: "甲醛治理", MenuIcon: "https://cloudimage.qxdaojia.com/gooods/1654567066455-17.png" },
        { MenuName: "石材护理", MenuIcon: "https://cloudimage.qxdaojia.com/gooods/1655861372223-7.png" },
        { MenuName: "白蚁防治", MenuIcon: "https://cloudimage.qxdaojia.com/gooods/1654567073752-18.png" },
        { MenuName: "地毯清洗", MenuIcon: "https://cloudimage.qxdaojia.com/gooods/1654567080002-19.png" },
        { MenuName: "木板护理", MenuIcon: "https://cloudimage.qxdaojia.com/gooods/1654844174056-Mask group-11.png" },
        { MenuName: "除螨除尘", MenuIcon: "https://cloudimage.qxdaojia.com/gooods/1654567073752-18.png" },
        { MenuName: "新居开荒", MenuIcon: "https://cloudimage.qxdaojia.com/gooods/1655861387493-9.png" },
        { MenuName: "更多", MenuIcon: "https://cloudimage.qxdaojia.com/gooods/1654567052019-15.png" },
      ],
      promotionsList:[
        { MenuName: "家庭保洁", MenuIcon: "https://img10.360buyimg.com/mobilecms/s360x360_jfs/t1/123437/36/24819/392660/62ce9311E0613a49a/766d6cf49d8f9d4f.jpg!q70.dpg.webp" },
        { MenuName: "保姆月嫂", MenuIcon: "https://img10.360buyimg.com/mobilecms/s360x360_jfs/t1/75590/36/19762/383192/62b95a8cE585b5831/63c1ec509cd1d4a5.jpg!q70.dpg.webp" },
      ]

    }
  },
  mounted() {
    this.$nextTick(() => {
      let phoneWidth = document.documentElement.clientWidth; // 手机宽度
      this.imgHeight = (phoneWidth - 24) / 2.5 + "px";
      // console.log(this.imgHeight)
    });
  },
  methods: {
    selectMenu() { }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.home-wrap{
  box-sizing: border-box;
  .home-top-wrap{
    padding: 0px 12px;
    box-sizing: border-box;
    background:  #009933;
    .top-header{
      padding: 12px 0px;
     
      box-sizing: border-box;
      display: flex
      justify-content: space-between;
      .header-left{
        font-size: 14px;
        display: flex;
        align-items: center;
        .city-name{
          margin: 0px 4px;
        }
      }
    }
    
    .swipe-wrap{
      border-radius: 8px !important;
      box-sizing: border-box;
      .swipe-content {
        box-sizing: border-box;
        border-radius: 8px !important;
        overflow: hidden !important;
        .my-swipe {
          box-sizing: border-box;
          border-radius: 8px !important;
          overflow: hidden !important;
          .swipe-inner {
            box-sizing: border-box;
            .swipe-inner-img {
              box-sizing: border-box;
            }
          }
        }

      }
    }
   
  }
  .menu-list-wrap{
    padding: 0px 12px;
    margin: 12px 0px;
    box-sizing: border-box;
    .menu-wrap {
      box-sizing: border-box;
      background: #fff;
      .menu-body {
        display: flex;
        flex-wrap: wrap;
        .menu-item {
          box-sizing: border-box;
          width: 25%;
          padding-bottom: 12px;
          .menu-item-inner {
            box-sizing: border-box;
            width: 100%;
            padding: 10px 10px 6px 10px; 
            .menu-item-inner-inner {
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              font-size: 14px;
              background-color: #fff;
              color: #fff;
            }
          }

          .menu-item-name {
            font-size: 14px;
            line-height: 1.4;
            text-align: center;
            color: #666;
          }
        }
      }
    }
  }
  .promotions-wrap{
    box-sizing: border-box;
    padding: 12px 0px;
    .promotions-title{
      box-sizing: border-box;
    }
    .promotions-body {
      display: flex;
      flex-wrap: wrap;
      .promotions-item {
        box-sizing: border-box;
        width: 50%;
        padding-bottom: 12px;
        .promotions-item-inner {
          box-sizing: border-box;
          width: 100%;
          padding: 10px 10px 6px 10px; 
          .promotions-item-inner-inner {
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            background-color: #fff;
            color: #fff;
            border-radius: 16px;
            overflow: hidden;
          }
        }
        .promotions-item-name {
          font-size: 14px;
          line-height: 1.4;
          text-align: center;
          color: #666;
        }
      }
    }
  }
  
}
</style>


// WEBPACK FOOTER //
// src/pages/Home/HomeNew.vue